import { render, staticRenderFns } from "./Selectpicker.vue?vue&type=template&id=3f986e4f&lang=pug"
import script from "./Selectpicker.vue?vue&type=script&lang=js"
export * from "./Selectpicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports